'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LinkButton = require('../buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

require('./RetryErrorComponent.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var RetryErrorComponent = function RetryErrorComponent(_ref) {
    var message = _ref.message,
        retryFn = _ref.retryFn;
    return _react2.default.createElement(
        'div',
        { className: 'RetryErrorComponent' },
        _react2.default.createElement(
            'span',
            { className: 'message' },
            message
        ),
        _react2.default.createElement(
            _LinkButton2.default,
            { className: 'error', onClickFn: retryFn },
            'Try again'
        )
    );
};

// Styles


RetryErrorComponent.propTypes = {
    message: _propTypes2.default.string.isRequired,
    retryFn: _propTypes2.default.func.isRequired
};

exports.default = RetryErrorComponent;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/RetryErrorComponent.js
// module id = 694
// module chunks = 0